<template>
  <section class="package checked-lists" :class="{'open':data.enabled}">
    <div class="package-title">
      <div
          class="toggle package"
          :class="{'active':data.enabled}"
          @click="toggle"
      ></div>
      <div class="title-wrapper" @click="toggle">
        <div class="title">{{ data.title }}</div>
        <span class="caret icon-caret"></span>
      </div>
    </div>
    <div class="content" :class="{'disabled' : !data.enabled}">
      <div v-html="data.description"></div>
      <div class="options" v-if="Object.keys(data.options).length">
        <div class="options-title">Optionen {{ data.title }}</div>
        <package-option v-for="option in data.options" :data="option" :key="option.key"/>
      </div>
    </div>
    <div class="price" v-html="`${priceMonthly}/Mt.`"></div>
  </section>
</template>

<script>
import Option from "./Option";

export default {
  name: "Package",
  props: {
    data: Object,
    initialEnabled: Boolean
  },
  computed: {
    price() {
      return this.$parent.packagePrice(this.data);
    },
    priceMonthly() {
      return this.$parent.formatPrice(this.price);
    }
  },
  methods: {
    toggle() {
      this.$root.$emit('packageToggled', this.data.key)
    },
  },
  mounted() {
    if (this.initialEnabled) {
      this.toggle();
    }
  },
  components: {'PackageOption': Option}
}
</script>
